module.exports = __webpack_public_path__ + "822e4793e34e4f530b8c32bd4dd7d5fb.svg";